import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { RIDE_ACT, RIDE_DEL, RIDE_DET, RIDE_ENABLE, RIDE_LIST, RIDE_LIST_PARC, RIDE_QUEUE, RIDE_SAVE } from "./action-types";

// Liste des attractions
export function listRides() {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/rides`;
        let datas = [];

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: RIDE_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("rili002");
                dispatch({
                    type: RIDE_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Liste des attractions par parc
export function listRidesParc({parcId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/rides-parc/${parcId}`;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: RIDE_LIST_PARC,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("ripa002");
                dispatch({
                    type: RIDE_LIST_PARC,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Liste des attractions actifs par parc
export function listRidesActive({parcs}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/waitime/rides`;

        axios.post(url, {
            parcs: parcs,
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: RIDE_ACT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("wari002");
                
                dispatch({
                    type: RIDE_ACT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Trouver les détails d'une attraction sur queue times
export function detRidequeue({id}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;
        let url = `${getDomain()}api/rides/queuetimes`;

        axios.post(url, {
            id: id
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);
                
                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: RIDE_QUEUE,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err)
                alert = tempAlErr("riqu002");
                dispatch({
                    type: RIDE_QUEUE,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}
// Détails d'une attraction
export function detailsRide({id}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/ride/${id}`;
        let datas = null;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: RIDE_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("ridt002");
                dispatch({
                    type: RIDE_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Sauvegarde d'activation/désactivation d'une attraction
export function setEnableRide({rideId, isActive}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/enable-ride/${rideId}`;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            isActive: isActive
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.code);

                if (res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: RIDE_ENABLE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("rien004");
                dispatch({
                    type: RIDE_ENABLE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Sauvegarde d'une attraction
export function saveRide({
    rideId,
    nameOr,
    nameFr,
    parcId,
    isActive,
    id = null
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/rides/save`;

        if (id != null) {
            url += `/${id}`;
        }

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            rideId: rideId,
            nameOr: nameOr,
            nameFr: nameFr,
            parcId: parcId,
            isActive: isActive
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: RIDE_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("risa005");
                dispatch({
                    type: RIDE_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Suppression d'une attraction
export function deleteRide({id}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/rides/delete/${id}`;

        axios.post(url, {
            credentials: localStorage.getItem('userCred'),
            userId: localStorage.getItem('userId')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: RIDE_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("ride004");
                dispatch({
                    type: RIDE_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}